import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import ThreeColumnLayout from '../../containers/three-column-layout';
//import OneColumnLayout from '../../blocks/one-column-layout';
//import TwoColumnLayout from '../../blocks/two-column-layout';
//import FourColumnLayout from '../../blocks/four-column-layout';
import Photogallery from '../../blocks/photogallery';
import Presentation from '../../blocks/presentation';
import Slideshow from '../../blocks/slideshow';
import Slidegallery from '../../blocks/slidegallery';
import Promo from '../../containers/promo';
import Video from '../../blocks/video';
import Html from '../../containers/html';
import Wysiwyg from '../../containers/wysiwyg';

const ThreeColumnLayoutBlock = props => <ThreeColumnLayout {...props} />;
ThreeColumnLayoutBlock.displayName = 'ThreeColumnLayout';

export default withDynamicComponents({
  componentWhitelist: [
    //OneColumnLayout,
    //TwoColumnLayout,
    //FourColumnLayout,
    Photogallery,
    Presentation,
    Slideshow,
    Slidegallery,
    Promo,
    Wysiwyg,
    Video,
    Html,
  ],
  mapInputToOutput: [
    ['firstContent', 'firstContent'],
    ['secondContent', 'secondContent'],
    ['thirdContent', 'thirdContent'],
  ],
})(ThreeColumnLayoutBlock);



// WEBPACK FOOTER //
// ./src/blocks/three-column-layout/index.jsx